import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

interface ICompareFile {
    url: string;
    name?: string;
    format?: 'pdf' | 'image' | 'unknown';
}

interface IViewerState {
    zoom: number;
    rotation: number;
    isDragging: boolean;
    dragStartX: number;
    dragStartY: number;
    translateX: number;
    translateY: number;
}

@Component({
    selector: 'app-compare-viewer',
    templateUrl: './compare-viewer.component.html',
    styleUrls: ['./compare-viewer.component.scss'],
})
export class CompareViewerComponent implements OnChanges {

    @Input('files') Files: { url: string; name?: string }[] = [];

    public ResolvedFiles: ICompareFile[] = [];

    public ViewerState: IViewerState[] = [];

    ngOnChanges(changes: SimpleChanges) {

        if (!changes.Files) return;

        this.ResolvedFiles = (this.Files || []).slice(0, 2).map(file => ({
            url: file?.url || '',
            name: file?.name || '',
            format: this.getFileType(file?.name || file?.url || '')
        }));

        this.ViewerState = this.ResolvedFiles.map(() => this.createViewerState());
    }

    private createViewerState(): IViewerState {
        return { zoom: 1, rotation: 0, isDragging: false, dragStartX: 0, dragStartY: 0, translateX: 0, translateY: 0 };
    }

    Reset(index: number) {
        this.ViewerState[index] = this.createViewerState();
    }

    Rotate(index: number, deg: number) {
        this.ViewerState[index].rotation += deg;
    }

    ZoomIn(index: number) {
        if (this.ViewerState[index].isDragging) return;
        this.ViewerState[index].zoom += 0.1;
    }

    ZoomOut(index: number) {
        const state = this.ViewerState[index];
        if (state.isDragging) return;
        if (state.zoom > 0.2) state.zoom -= 0.1;
    }

    StartDrag(index: number, event: MouseEvent) {
        const state = this.ViewerState[index];
        if (state.zoom <= 1) return;
        state.isDragging = true;
        state.dragStartX = event.clientX - state.translateX;
        state.dragStartY = event.clientY - state.translateY;
    }

    OnDrag(index: number, event: MouseEvent) {
        const state = this.ViewerState[index];
        if (!state.isDragging) return;
        state.translateX = event.clientX - state.dragStartX;
        state.translateY = event.clientY - state.dragStartY;
    }

    EndDrag(index: number) {
        this.ViewerState[index].isDragging = false;
    }

    OnWheel(index: number, event: WheelEvent) {

        event.preventDefault();

        const state = this.ViewerState[index];

        if (state.isDragging) return;

        const delta = event.deltaY > 0 ? -0.1 : 0.1;
        state.zoom = Math.min(Math.max(state.zoom + delta, 1), 5);
    }

    private getFileType(fileName: string): 'pdf' | 'image' | 'unknown' {
        if (!fileName) return 'unknown';

        const dotIndex = fileName.lastIndexOf('.');
        if (dotIndex === -1 || dotIndex === fileName.length - 1) return 'unknown';

        const ext = fileName.substring(dotIndex + 1).toLowerCase();

        if (ext === 'pdf') return 'pdf';

        const IMAGE_EXTS = new Set(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tif', 'tiff', 'svg', 'heic', 'avif']);

        return IMAGE_EXTS.has(ext) ? 'image' : 'unknown';
    }

}
